import useSSE from '../useSSE';
import React, { useState, useEffect, useRef } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';

function Avatar({ name, color, size=28 }) {
  const initials = (name||'?').split(' ').map(w=>w[0]).slice(0,2).join('').toUpperCase();
  return (
    <div style={{width:size,height:size,borderRadius:'50%',background:color||'#5B5BD6',display:'flex',alignItems:'center',justifyContent:'center',fontSize:size*.34,fontWeight:'700',color:'#fff',flexShrink:0}}>
      {initials}
    </div>
  );
}

const Ic = {
  Grid:  ()=><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><rect x="1" y="1" width="5" height="5" rx="1.2" fill="currentColor" opacity=".9"/><rect x="8" y="1" width="5" height="5" rx="1.2" fill="currentColor" opacity=".6"/><rect x="1" y="8" width="5" height="5" rx="1.2" fill="currentColor" opacity=".6"/><rect x="8" y="8" width="5" height="5" rx="1.2" fill="currentColor" opacity=".35"/></svg>,
  Folder:()=><svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M1 3.2A1.2 1.2 0 012.2 2h2.18a1.2 1.2 0 01.85.35l.6.65A1.2 1.2 0 006.68 3.3H10.8A1.2 1.2 0 0112 4.5v5.7A1.2 1.2 0 0110.8 11.4H2.2A1.2 1.2 0 011 10.2z" fill="currentColor" opacity=".8"/></svg>,
  List:  ()=><svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M2 3.5h9M2 6.5h9M2 9.5h6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/></svg>,
  Chev:  ()=><svg width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M1.5 3l3 3 3-3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Plus:  ()=><svg width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M5.5 1v9M1 5.5h9" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/></svg>,
  Bell:  ()=><svg width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M7.5 1.5A4.5 4.5 0 003 6v2.5l-1 1.5v.5h11v-.5l-1-1.5V6A4.5 4.5 0 007.5 1.5z" stroke="currentColor" strokeWidth="1.3"/><path d="M6 12.5a1.5 1.5 0 003 0" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/></svg>,
  Users: ()=><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="5" cy="4.5" r="2" fill="currentColor" opacity=".8"/><circle cx="9.5" cy="4.5" r="1.5" fill="currentColor" opacity=".5"/><path d="M1 11c0-2.21 1.79-4 4-4s4 1.79 4 4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" fill="none"/><path d="M9.5 7.5c1.38 0 2.5 1.12 2.5 2.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" fill="none" opacity=".6"/></svg>,
  Logout:()=><svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M5 2H3A1.5 1.5 0 001.5 3.5v6A1.5 1.5 0 003 11h2M8.5 9L12 6.5 8.5 4M5 6.5h7" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  WBS:   ()=><svg width="13" height="13" viewBox="0 0 13 13" fill="none"><rect x="4.5" y="1" width="4" height="2.5" rx="1" stroke="currentColor" strokeWidth="1.2"/><rect x="1" y="9.5" width="3.5" height="2.5" rx="1" stroke="currentColor" strokeWidth="1.2"/><rect x="4.75" y="9.5" width="3.5" height="2.5" rx="1" stroke="currentColor" strokeWidth="1.2"/><rect x="8.5" y="9.5" width="3.5" height="2.5" rx="1" stroke="currentColor" strokeWidth="1.2"/><path d="M6.5 3.5v3M2.75 8.5V6.5h7.5v2" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/></svg>,
  Gantt: ()=><svg width="13" height="13" viewBox="0 0 13 13" fill="none"><rect x="1" y="2.5" width="6" height="2" rx="1" fill="currentColor" opacity=".8"/><rect x="4" y="5.5" width="8" height="2" rx="1" fill="currentColor" opacity=".6"/><rect x="1" y="8.5" width="4" height="2" rx="1" fill="currentColor" opacity=".5"/></svg>,
  Payment: ()=><svg width="13" height="13" viewBox="0 0 13 13" fill="none"><rect x="1" y="2" width="11" height="9" rx="2" stroke="currentColor" strokeWidth="1.3"/><path d="M1 5h11" stroke="currentColor" strokeWidth="1.3"/><rect x="3" y="7.5" width="3" height="1.5" rx="0.5" fill="currentColor"/></svg>,
  Resource: ()=><svg width="13" height="13" viewBox="0 0 13 13" fill="none"><rect x="1" y="3" width="11" height="2" rx="1" fill="currentColor"/><rect x="1" y="7" width="7" height="2" rx="1" fill="currentColor"/><rect x="1" y="11" width="9" height="2" rx="1" fill="currentColor"/></svg>,
  Time:  ()=><svg width="13" height="13" viewBox="0 0 13 13" fill="none"><circle cx="6.5" cy="6.5" r="5" stroke="currentColor" strokeWidth="1.3"/><path d="M6.5 3.5v3l2 1.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/></svg>,
};

export default function AppShell() {
  const { user, logout } = useAuth();
  const isGuest = user?.role === 'guest';
  const navigate = useNavigate();
  const location = useLocation();
  const [spaces, setSpaces] = useState([]);
  const [expandedSpaces, setExpandedSpaces] = useState({});
  const [expandedFolders, setExpandedFolders] = useState({});
  const dragList = useRef(null);
  const dragOverList = useRef(null);
  const dragListFolder = useRef(null);
  const [spaceData, setSpaceData] = useState({});
  const [notifications, setNotifications] = useState([]);
  const [showNotifs, setShowNotifs] = useState(false);
  const [showSpaceModal, setShowSpaceModal] = useState(false);
  const [newSpace, setNewSpace] = useState({name:'',description:'',color:'#5B5BD6',visibility:'private'});
  const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth > 768);
  const COLORS = ['#5B5BD6','#2563EB','#0891B2','#16A34A','#D97706','#DC2626','#EC4899','#7C3AED'];

  useEffect(() => { loadSpaces(); loadNotifications(); }, []);

  // Refresh sidebar on window focus (user returns to tab)
  useEffect(() => {
    const onFocus = () => { loadSpaces(); };
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, []);

  // Refresh sidebar on route change — new projects/access appear immediately
  useEffect(() => {
    loadSpaces();
  }, [location?.pathname]);

  // Auto-expand active space when URL changes
  useEffect(() => {
    const match = location.pathname.match(/\/spaces\/([^/]+)/);
    if (match) {
      const sid = match[1];
      setExpandedSpaces(p => ({ ...p, [sid]: true }));
      if (!spaceData[sid]) loadSpaceFolders(sid);
    }
  }, [location.pathname, spaces.length]);

  // Real-time: refresh sidebar - extract spaceId from current URL
  // Extract spaceId from any URL pattern (spaces/:id, phases/:id → lookup, lists/:id → lookup)
  const [_activeSpaceId, _setActiveSpaceId] = useState(null);
  const _sseSpaceId = React.useMemo(() => {
    // Direct: /spaces/:id/...
    const mSpace = location.pathname.match(/\/spaces\/([^/]+)/);
    if (mSpace) return mSpace[1];
    // From stored active space (set when navigating to phase/list pages)
    return _activeSpaceId;
  }, [location.pathname, _activeSpaceId]);

  // When on a phase/list page, try to find the parent spaceId
  useEffect(() => {
    const mPhase = location.pathname.match(/\/phases\/([^/]+)/);
    const mList  = location.pathname.match(/\/lists\/([^/]+)/);
    if (mPhase || mList) {
      // Look up spaceId from all loaded spaces
      for (const sp of spaces) {
        const data = spaceData[sp.id];
        if (!data) continue;
        if (mPhase) {
          const found = (data.folders||[]).find(f => mPhase[1] === f.id);
          if (found) { _setActiveSpaceId(sp.id); return; }
        }
        if (mList) {
          for (const f of (data.folders||[])) {
            const found2 = (f.lists||[]).find(l => mList[1] === l.id);
            if (found2) { _setActiveSpaceId(sp.id); return; }
          }
        }
      }
    }
  }, [location.pathname, spaces, spaceData]);
  useSSE('__appshell__', {  // AppShell receives ALL events via wildcard in singleton
    // H4 client-side: handle session_expired sent by server when token is revoked
    session_expired: () => {
      localStorage.removeItem('flowup_token');
      document.cookie = 'trajectory_token=; Max-Age=0; path=/';
      window.location.href = '/login';
    },
    phase_created:  (evt) => { const sid = evt?.projectId||_sseSpaceId; if(sid) loadSpaceFolders(sid); },
    phase_updated:  (evt) => {
      const sid = evt?.projectId||_sseSpaceId;
      if(sid) { loadSpaceFolders(sid); }
      // Also dispatch window event so phase dashboard page reloads
      window.dispatchEvent(new CustomEvent('trajectory:access_changed', { detail: evt }));
    },
    phase_deleted:  (evt) => {
      const sid = evt?.projectId||_sseSpaceId;
      if(sid) { loadSpaceFolders(sid); }
      window.dispatchEvent(new CustomEvent('trajectory:access_changed', { detail: evt }));
    },
    list_created:   (evt) => { const sid = evt?.projectId||_sseSpaceId; if(sid) loadSpaceFolders(sid); },
    list_deleted:   (evt) => { const sid = evt?.projectId||_sseSpaceId; if(sid) loadSpaceFolders(sid); },
    list_updated:   (evt) => { const sid = evt?.projectId||_sseSpaceId; if(sid) loadSpaceFolders(sid); },
    task_updated:   (evt) => { const sid = evt?.projectId||_sseSpaceId; if(sid) loadSpaceFolders(sid); },
    // Global access events — reload spaces AND folders immediately
    access_changed: (evt) => {
      // Reload full spaces list immediately
      loadSpaces();
      // Reload ALL loaded spaces' folders so sidebar reflects permission changes
      if (evt?.projectId) {
        loadSpaceFolders(evt.projectId);
      }
      // Also reload ALL other loaded spaces (belt and suspenders)
      Object.keys(spaceData).forEach(sid => { if(sid !== evt?.projectId) loadSpaceFolders(sid); });
      // Notify current page so it can re-check its own access
      window.dispatchEvent(new CustomEvent('trajectory:access_changed', { detail: evt }));
    },
  });

  // Auto-expand folder containing active list
  useEffect(() => {
    const listMatch = location.pathname.match(/\/lists\/([^/]+)/);
    if (!listMatch) return;
    const activeListId = listMatch[1];
    Object.values(spaceData).forEach(sd => {
      sd.folders?.forEach(folder => {
        if (folder.lists?.some(l => l.id === activeListId)) {
          setExpandedFolders(p => ({ ...p, [folder.id]: true }));
        }
      });
    });
  }, [spaceData, location.pathname]);

  async function loadSpaces() {
    try {
      const data = await api.get('/spaces');
      setSpaces(Array.isArray(data) ? data : []);
    } catch(e) {
      console.error('loadSpaces error:', e);
      setSpaces([]);
    }
  }

  async function reorderLists(folderId, dragId, overId) {
    if (!dragId || !overId || dragId === overId) return;
    try {
      const folder = spaceFolders[folderId];
      if (!folder?.lists) return;
      const lists = [...folder.lists];
      const fi = lists.findIndex(l=>l.id===dragId);
      const ti = lists.findIndex(l=>l.id===overId);
      if (fi===-1||ti===-1) return;
      lists.splice(ti,0,lists.splice(fi,1)[0]);
      await api.put(`/folders/${folderId}/reorder-lists`,{orderedIds:lists.map(l=>l.id)});
      loadSpaceFolders(folderId.split('-')[0]);
    } catch(e) { console.error('List reorder failed',e); }
  }

  async function loadSpaceFolders(spaceId) {
    try {
      const folders = await api.get(`/spaces/${spaceId}/folders`);
      const foldersWithLists = await Promise.all(folders.map(async f => {
        const lists = await api.get(`/folders/${f.id}/lists`).catch(()=>[]);
        return { ...f, lists };
      }));
      setSpaceData(p => ({ ...p, [spaceId]: { folders: foldersWithLists } }));
    } catch(e) {}
  }

  async function loadNotifications() {
    try { setNotifications(await api.get('/notifications')); } catch(e) {}
  }

  async function createSpace() {
    if (!newSpace.name.trim()) return;
    try {
      const created = await api.post('/spaces', newSpace);
      setShowSpaceModal(false);
      setNewSpace({name:'',description:'',color:'#5B5BD6',visibility:'private'});
      await loadSpaces(); // reload list so SpacePage gets updated context
      // auto-navigate to new project
      if (created?.id) navigate(`/spaces/${created.id}`);
    } catch(e) { console.error('AppShell error:', e); }
  }

  const isAt = p => location.pathname === p;
  const isIn = p => location.pathname.startsWith(p);
  const unread = notifications.filter(n=>!n.is_read).length;

  return (
    <div style={{display:'flex',height:'100vh',overflow:'hidden',background:'var(--bg)'}}>

      {/* Mobile overlay — tap to close sidebar */}
      {sidebarOpen && window.innerWidth <= 768 && (
        <div onClick={()=>setSidebarOpen(false)}
          style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',zIndex:99,display:'block'}}/>
      )}

      {/* SIDEBAR — collapsible */}
      <aside style={{
        width: sidebarOpen ? '236px' : '0px',
        flexShrink:0, background:'var(--surface)',
        borderRight: sidebarOpen ? '1px solid var(--border)' : 'none',
        display:'flex', flexDirection:'column', overflow:'hidden',
        transition:'width .22s cubic-bezier(.4,0,.2,1)',
        position: window.innerWidth <= 768 ? 'fixed' : 'relative',
        top: 0, left: 0, height: '100vh',
        zIndex: 100,
      }}>

        {/* Logo + SCT branding */}
        <div style={{padding:'12px 14px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:'10px',flexShrink:0}}>
          <div style={{width:'32px',height:'32px',borderRadius:'9px',background:'linear-gradient(135deg,#5B5BD6,#7C3AED)',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:'900',color:'#fff',fontSize:'15px',flexShrink:0,boxShadow:'0 2px 10px rgba(91,91,214,0.4)',letterSpacing:'-0.5px'}}>T</div>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontSize:'14px',fontWeight:'800',color:'var(--text)',letterSpacing:'-0.4px'}}>EOMP</div>
            <div style={{fontSize:'9px',color:'var(--muted)',textTransform:'capitalize',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',letterSpacing:'0.3px'}}>{user?.full_name||user?.role}</div>
          </div>
          <img src="/sct-logo.png" alt="SCT" style={{height:'28px',opacity:.7,flexShrink:0}} title="Space Communication Technologies"/>
          <button
            onClick={()=>setSidebarOpen(v=>!v)}
            title="Collapse sidebar"
            style={{marginLeft:'auto',background:'var(--surface2)',border:'1px solid var(--border)',cursor:'pointer',color:'var(--text)',padding:'6px 8px',borderRadius:'8px',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,lineHeight:1,transition:'all .18s',gap:'0'}}
            onMouseEnter={e=>{e.currentTarget.style.background='var(--brand)';e.currentTarget.style.borderColor='var(--brand)';e.currentTarget.style.color='#fff';}}
            onMouseLeave={e=>{e.currentTarget.style.background='var(--surface2)';e.currentTarget.style.borderColor='var(--border)';e.currentTarget.style.color='var(--text)';}}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M3 4h10M3 8h10M3 12h10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
              <path d="M11 4L7 8l4 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" opacity="0.6"/>
            </svg>
          </button>
        </div>

        {/* Nav */}
        <nav style={{flex:1,overflowY:'auto',padding:'8px 10px'}}>
          <SbItem icon={<Ic.Grid/>} label="Portfolio" to="/spaces" active={isAt('/spaces')} navigate={navigate}/>
          {(user?.role==='superadmin'||user?.role==='admin') && (
            <SbItem icon={<Ic.Users/>} label="App Settings" to="/users" active={isIn('/users')} navigate={navigate}/>
          )}

          {/* Projects section header */}
          <div style={{padding:'14px 8px 4px',fontSize:'10px',fontWeight:'700',textTransform:'uppercase',letterSpacing:'1px',color:'var(--muted)',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
            <span>Portfolio</span>
            <SbIconBtn icon={<Ic.Plus/>} onClick={()=>setShowSpaceModal(true)} title="New Project"/>
          </div>

          {spaces.length === 0 && (
            <div style={{padding:'6px 10px',fontSize:'12px',color:'var(--muted)',fontStyle:'italic'}}>No projects yet</div>
          )}

          {spaces.map(sp => {
            const spOpen = !!expandedSpaces[sp.id];
            const data = spaceData[sp.id];
            const spActive = isIn(`/spaces/${sp.id}`);

            return (
              <div key={sp.id}>
                {/* Project row */}
                <SpaceRow
                  sp={sp} spOpen={spOpen} spActive={spActive}
                  onToggle={() => {
                    setExpandedSpaces(p => ({...p, [sp.id]: !p[sp.id]}));
                    if (!spaceData[sp.id]) loadSpaceFolders(sp.id);
                  }}
                  onNavigate={() => navigate(`/spaces/${sp.id}`)}
                />

                {/* Expanded content */}
                {spOpen && (
                  <div style={{paddingLeft:'14px',marginBottom:'4px'}}>
                    {/* Quick links removed from sidebar — now shown as tabs in DashboardPage */}

                    {!data && <div style={{fontSize:'11px',color:'var(--muted)',padding:'3px 8px'}}>Loading…</div>}
                    {data?.folders?.length === 0 && <div style={{fontSize:'11px',color:'var(--muted)',padding:'3px 8px',fontStyle:'italic'}}>No phases yet</div>}

                    {data?.folders?.map(folder => {
                      const fOpen = !!expandedFolders[folder.id];
                      return (
                        <div key={folder.id}>
                          <FolderRow
                            folder={folder} fOpen={fOpen}
                            onToggle={() => setExpandedFolders(p => ({...p, [folder.id]: !p[folder.id]}))}
                            onPhaseClick={() => navigate(`/phases/${folder.id}/dashboard`)}
                          />
                          {fOpen && (
                            <div style={{paddingLeft:'14px',marginBottom:'2px'}}>
                              {folder.lists?.length === 0 && <div style={{fontSize:'11px',color:'var(--muted)',padding:'2px 6px',fontStyle:'italic'}}>No milestones</div>}
                              {folder.lists?.map(lst => (
                                <div key={lst.id}
                                  draggable
                                  onDragStart={()=>{dragList.current=lst.id;dragListFolder.current=folder.id;}}
                                  onDragEnter={()=>{dragOverList.current=lst.id;}}
                                  onDragEnd={()=>{
                                    if(dragList.current&&dragOverList.current&&dragListFolder.current){
                                      reorderLists(dragListFolder.current,dragList.current,dragOverList.current);
                                      dragList.current=null;dragOverList.current=null;dragListFolder.current=null;
                                    }
                                  }}
                                  onDragOver={e=>e.preventDefault()}
                                  style={{cursor:'grab'}}>
                                  <MilestoneRow
                                    lst={lst}
                                    active={isAt(`/lists/${lst.id}`)}
                                    onClick={() => navigate(`/lists/${lst.id}`)}
                                  />
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </nav>

        {/* Bottom user row */}
        <div style={{padding:'10px 8px',borderTop:'1px solid var(--border)'}}>
          <UserRow user={user} onLogout={() => { logout(); navigate('/login'); }}/>
        </div>
      </aside>

      {/* MAIN */}
      <div style={{flex:1,display:'flex',flexDirection:'column',minWidth:0,minHeight:0,overflow:'hidden'}}>
        {/* Top bar */}
        <header style={{height:'46px',flexShrink:0,background:'var(--surface)',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',justifyContent:'flex-end',padding:'0 20px',gap:'8px'}}>
          {!sidebarOpen && (
            <button onClick={()=>setSidebarOpen(true)} title="Open menu"
              style={{marginRight:'auto',background:'none',border:'none',cursor:'pointer',padding:'4px 8px',color:'var(--text)',display:'flex',alignItems:'center',gap:'6px',fontSize:'13px',fontWeight:'600',borderRadius:'6px'}}>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M2 4.5h14M2 9h14M2 13.5h14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>
            </button>
          )}
          <button onClick={()=>navigate('/hub')} title="App Hub — switch applications"
            style={{display:'flex',alignItems:'center',justifyContent:'center',width:'32px',height:'32px',borderRadius:'8px',border:'1px solid var(--border)',background:'var(--surface2)',color:'var(--muted2)',cursor:'pointer',transition:'all .15s'}}
            onMouseEnter={e=>{e.currentTarget.style.background='var(--brand)';e.currentTarget.style.borderColor='var(--brand)';e.currentTarget.style.color='#fff';}}
            onMouseLeave={e=>{e.currentTarget.style.background='var(--surface2)';e.currentTarget.style.borderColor='var(--border)';e.currentTarget.style.color='var(--muted2)';}}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><rect x="2" y="2" width="4.5" height="4.5" rx="1" fill="currentColor"/><rect x="9.5" y="2" width="4.5" height="4.5" rx="1" fill="currentColor"/><rect x="2" y="9.5" width="4.5" height="4.5" rx="1" fill="currentColor"/><rect x="9.5" y="9.5" width="4.5" height="4.5" rx="1" fill="currentColor"/></svg>
          </button>
          <div style={{position:'relative'}}>
            <button className="btn-icon" onClick={()=>{setShowNotifs(!showNotifs);if(!showNotifs)api.put('/notifications/read-all').then(loadNotifications);}}>
              <Ic.Bell/>
              {unread>0&&<span style={{position:'absolute',top:'-3px',right:'-3px',background:'var(--red)',color:'#fff',borderRadius:'99px',fontSize:'9px',padding:'1px 4px',fontWeight:'700',minWidth:'14px',textAlign:'center'}}>{unread}</span>}
            </button>
            {showNotifs && (
              <>
                <div onClick={()=>setShowNotifs(false)} style={{position:'fixed',inset:0,zIndex:199}}/>
                <div style={{position:'absolute',top:'calc(100% + 8px)',right:0,width:'300px',background:'var(--surface)',border:'1px solid var(--border)',borderRadius:'var(--radius-lg)',zIndex:200,maxHeight:'360px',overflowY:'auto',boxShadow:'var(--shadow-lg)'}}>
                  <div style={{padding:'12px 16px',borderBottom:'1px solid var(--border)',fontWeight:'700',fontSize:'13px'}}>Notifications</div>
                  {notifications.length===0&&<div style={{padding:'20px',textAlign:'center',color:'var(--muted)',fontSize:'12px'}}>All caught up! 🎉</div>}
                  {notifications.slice(0,20).map(n=>(
                    <div key={n.id} style={{padding:'10px 16px',borderBottom:'1px solid var(--border)',background:n.is_read?'transparent':'rgba(91,91,214,0.04)'}}>
                      <div style={{fontSize:'12px',fontWeight:'600',marginBottom:'2px'}}>{n.title}</div>
                      <div style={{fontSize:'11px',color:'var(--muted)'}}>{n.message}</div>
                      <div style={{fontSize:'10px',color:'var(--muted)',marginTop:'2px'}}>{n.created_at?.slice(0,16)}</div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
          <Avatar name={user?.full_name} color={user?.avatar_color} size={28}/>
        </header>

        <main style={{flex:1,overflow:'auto',display:'flex',flexDirection:'column',minHeight:0}}>
          <Outlet context={{ spaces, reloadSpaces: loadSpaces, reloadSidebar: loadSpaceFolders, user, isGuest }}/>
        </main>
      </div>

      {/* Floating sidebar-open tab — visible only when sidebar is hidden */}
      {!sidebarOpen&&(
        <button
          onClick={()=>setSidebarOpen(true)}
          title="Show sidebar (expand menu)"
          style={{
            position:'fixed', left:0, top:'50%', transform:'translateY(-50%)',
            zIndex:999,
            background:'linear-gradient(135deg,#5B5BD6,#7C3AED)',
            border:'none',
            borderRadius:'0 12px 12px 0',
            padding:'16px 10px',
            cursor:'pointer',
            display:'flex', flexDirection:'column',
            alignItems:'center', gap:'6px',
            boxShadow:'3px 0 16px rgba(91,91,214,0.35)',
            transition:'all .2s',
          }}
          onMouseEnter={e=>{e.currentTarget.style.padding='16px 14px';e.currentTarget.style.boxShadow='4px 0 20px rgba(91,91,214,0.5)';}}
          onMouseLeave={e=>{e.currentTarget.style.padding='16px 10px';e.currentTarget.style.boxShadow='3px 0 16px rgba(91,91,214,0.35)';}}>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M3 5h12M3 9h12M3 13h12" stroke="white" strokeWidth="1.8" strokeLinecap="round"/>
          </svg>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style={{marginTop:'2px'}}>
            <path d="M4 3l5 4-5 4" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span style={{fontSize:'8px',fontWeight:'800',color:'rgba(255,255,255,0.9)',writingMode:'vertical-rl',letterSpacing:'1px',marginTop:'2px',textTransform:'uppercase'}}>Menu</span>
        </button>
      )}

      {/* Create Project Modal */}
      {showSpaceModal && (
        <div className="modal-overlay">
          <div className="modal" style={{width:'420px'}}>
            <h3 style={{fontSize:'16px',fontWeight:'700',marginBottom:'20px'}}>Create New Project</h3>
            <div className="form-group">
              <label className="form-label">Project Name</label>
              <input className="input" value={newSpace.name} onChange={e=>setNewSpace({...newSpace,name:e.target.value})}
                placeholder="e.g. Orbital Readiness, Network Expansion…" autoFocus
                onKeyDown={e=>e.key==='Enter'&&createSpace()}/>
            </div>
            <div className="form-group">
              <label className="form-label">Description</label>
              <input className="input" value={newSpace.description} onChange={e=>setNewSpace({...newSpace,description:e.target.value})} placeholder="Optional"/>
            </div>
            <div className="form-group">
              <label className="form-label">Color</label>
              <div style={{display:'flex',gap:'8px',flexWrap:'wrap'}}>
                {COLORS.map(c=>(
                  <div key={c} onClick={()=>setNewSpace({...newSpace,color:c})}
                    style={{width:26,height:26,borderRadius:'50%',background:c,cursor:'pointer',outline:newSpace.color===c?`3px solid ${c}`:'none',outlineOffset:'2px',transition:'outline .1s'}}/>
                ))}
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Visibility</label>
              <select className="select" value={newSpace.visibility} onChange={e=>setNewSpace({...newSpace,visibility:e.target.value})}>
                <option value="private">Private — invite only</option>
                <option value="public">Public — all workspace members</option>
              </select>
            </div>
            <div style={{display:'flex',gap:'8px',justifyContent:'flex-end',marginTop:'20px',paddingTop:'16px',borderTop:'1px solid var(--border)'}}>
              <button className="btn" onClick={()=>setShowSpaceModal(false)}>Cancel</button>
              <button className="btn btn-primary" onClick={createSpace}>Create Project</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Sub-components using React state for hover (no DOM mutation)

function SbItem({ icon, label, to, active, navigate }) {
  const [hov, setHov] = useState(false);
  return (
    <div onClick={()=>navigate(to)}
      onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}
      style={{display:'flex',alignItems:'center',gap:'10px',padding:'8px 11px',borderRadius:'var(--radius)',cursor:'pointer',
        background:active?'var(--brand)':hov?'var(--surface2)':'transparent',
        color:active?'#fff':hov?'var(--text)':'var(--muted)',
        fontSize:'13px',fontWeight:active?'700':'500',
        transition:'all .12s',marginBottom:'2px'}}>
      <span style={{display:'flex',alignItems:'center',flexShrink:0}}>{icon}</span>
      <span style={{flex:1,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{label}</span>
    </div>
  );
}

function SbIconBtn({ icon, onClick, title }) {
  const [hov, setHov] = useState(false);
  return (
    <button onClick={onClick} title={title}
      onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}
      style={{background:'none',border:'none',color:hov?'var(--brand)':'var(--muted)',cursor:'pointer',padding:'2px',display:'flex',borderRadius:'4px',transition:'color .1s'}}>
      {icon}
    </button>
  );
}

function SpaceRow({ sp, spOpen, spActive, onToggle, onNavigate }) {
  const [hov, setHov] = useState(false);
  return (
    <div style={{display:'flex',alignItems:'center',borderRadius:'var(--radius)',marginBottom:'1px',background:spActive?'var(--brand-dim)':hov?'var(--surface3)':'none',transition:'background .12s'}}
      onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}>
      <button onClick={onToggle}
        style={{background:'none',border:'none',padding:'5px 3px 5px 5px',color:'var(--muted)',cursor:'pointer',display:'flex',flexShrink:0,transition:'transform .15s',transform:spOpen?'rotate(0)':'rotate(-90deg)'}}>
        <svg width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M1.5 3l3 3 3-3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/></svg>
      </button>
      <div onClick={onNavigate} style={{flex:1,display:'flex',alignItems:'center',gap:'7px',padding:'5px 8px 5px 0',cursor:'pointer',overflow:'hidden'}}>
        <span style={{width:8,height:8,borderRadius:'2px',background:sp.color,flexShrink:0,display:'inline-block'}}/>
        <span style={{fontSize:'13px',fontWeight:'600',color:spActive?'var(--brand)':'var(--text)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{sp.name}</span>
      </div>
    </div>
  );
}

function FolderRow({ folder, fOpen, onToggle, onPhaseClick }) {
  const [hov, setHov] = useState(false);
  return (
    <div style={{display:'flex',alignItems:'center',borderRadius:'var(--radius)',marginBottom:'1px',background:hov?'var(--surface3)':'none',transition:'background .12s'}}
      onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}>
      <button onClick={onToggle}
        style={{background:'none',border:'none',padding:'4px 3px 4px 4px',color:'var(--muted)',cursor:'pointer',display:'flex',flexShrink:0,transition:'transform .15s',transform:fOpen?'rotate(0)':'rotate(-90deg)'}}>
        <svg width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M1.5 3l3 3 3-3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/></svg>
      </button>
      <div style={{flex:1,display:'flex',alignItems:'center',gap:'5px',padding:'4px 8px 4px 0',overflow:'hidden'}}
        onClick={onPhaseClick} title="Click to view phase dashboard">
        <span style={{flexShrink:0,fontSize:'12px'}}>📋</span>
        <span style={{fontSize:'12px',fontWeight:'600',color:'var(--muted2)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',flex:1,cursor:'pointer'}}>{folder.name}</span>
        <span style={{fontSize:'9px',color:'var(--muted)',flexShrink:0,background:'var(--surface3)',padding:'1px 5px',borderRadius:'99px'}}>Phase</span>
      </div>
    </div>
  );
}

function MilestoneRow({ lst, active, onClick }) {
  const [hov, setHov] = useState(false);
  return (
    <div onClick={onClick}
      onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}
      style={{display:'flex',alignItems:'center',gap:'5px',padding:'4px 8px',borderRadius:'var(--radius)',cursor:'pointer',marginBottom:'1px',background:active?'var(--brand-dim)':hov?'var(--surface3)':'none',transition:'background .12s'}}>
      <span style={{color:active?'var(--brand)':'#0891B2',flexShrink:0}}>
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M2 3.5h9M2 6.5h9M2 9.5h6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/></svg>
      </span>
      <span style={{fontSize:'12px',fontWeight:'500',color:active?'var(--brand)':'var(--muted2)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',flex:1}}>{lst.name}</span>
      <span style={{fontSize:'9px',color:'var(--muted)',flexShrink:0}}>List</span>
    </div>
  );
}

function QuickPill({ icon, label, active, onClick }) {
  const [hov, setHov] = useState(false);
  return (
    <span onClick={onClick}
      onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}
      style={{fontSize:'10px',padding:'2px 7px',borderRadius:'99px',background:active||hov?'var(--brand-dim)':'var(--surface3)',color:active||hov?'var(--brand)':'var(--muted)',cursor:'pointer',display:'flex',alignItems:'center',gap:'3px',border:`1px solid ${active||hov?'rgba(91,91,214,0.2)':'var(--border)'}`,transition:'all .12s'}}>
      {icon}{label}
    </span>
  );
}

function UserRow({ user, onLogout }) {
  const [hov, setHov] = useState(false);
  const [btnHov, setBtnHov] = useState(false);
  const [showPrefs, setShowPrefs] = useState(false);
  const [showPw, setShowPw] = useState(false);
  return (
    <div style={{display:'flex',alignItems:'center',gap:'8px',padding:'7px 8px',borderRadius:'var(--radius)',background:hov?'var(--surface2)':'none',transition:'background .12s',cursor:'default'}}
      onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}>
      <Avatar name={user?.full_name} color={user?.avatar_color} size={27}/>
      <div style={{flex:1,minWidth:0}}>
        <div style={{fontSize:'12px',fontWeight:'600',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',color:'var(--text)'}}>{user?.full_name}</div>
        <div style={{fontSize:'10px',color:'var(--muted)'}}>@{user?.username}</div>
      </div>
      <button onClick={()=>setShowPw(true)} title="Change my password"
        style={{background:'none',border:'none',color:'var(--muted)',cursor:'pointer',padding:'3px',display:'flex',borderRadius:'4px'}}>
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M10 6V4.2a3 3 0 00-6 0V6M3.2 6h7.6a1 1 0 011 1v4a1 1 0 01-1 1H3.2a1 1 0 01-1-1V7a1 1 0 011-1zM7 8.6v1.2" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/></svg>
      </button>
      <button onClick={()=>setShowPrefs(true)} title="My notification preferences"
        style={{background:'none',border:'none',color:'var(--muted)',cursor:'pointer',padding:'3px',display:'flex',borderRadius:'4px'}}>
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 1.5a3 3 0 00-3 3v2.2L2.8 9.2h8.4L10 6.7V4.5a3 3 0 00-3-3zM5.6 11a1.4 1.4 0 002.8 0" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/></svg>
      </button>
      <button onClick={onLogout} title="Logout"
        onMouseEnter={()=>setBtnHov(true)} onMouseLeave={()=>setBtnHov(false)}
        style={{background:'none',border:'none',color:btnHov?'var(--red)':'var(--muted)',cursor:'pointer',padding:'3px',display:'flex',borderRadius:'4px',transition:'color .12s'}}>
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M5 2H3A1.5 1.5 0 001.5 3.5v6A1.5 1.5 0 003 11h2M8.5 9L12 6.5 8.5 4M5 6.5h7" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/></svg>
      </button>
      {showPrefs && <NotificationPrefsModal onClose={()=>setShowPrefs(false)}/>}
      {showPw && <ChangePasswordModal user={user} onClose={()=>setShowPw(false)} onLogout={onLogout}/>}
    </div>
  );
}

// Self-service password change — works for ANY account, including superadmin.
// Sends new_password to PUT /users/:id (self), which hashes+peppers it and
// invalidates all existing sessions. Requires the current password for safety.
function ChangePasswordModal({ user, onClose, onLogout }) {
  const [cur, setCur] = useState('');
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [state, setState] = useState('idle'); // idle | saving | done | error
  const [err, setErr] = useState('');
  // Mirror the server's strength rule so the user gets instant feedback.
  const rules = [
    [pw.length >= 12, 'At least 12 characters'],
    [/[A-Z]/.test(pw), 'One uppercase letter'],
    [/[a-z]/.test(pw), 'One lowercase letter'],
    [/[0-9]/.test(pw), 'One number'],
    [/[^A-Za-z0-9]/.test(pw), 'One special character'],
  ];
  const allOk = rules.every(r=>r[0]);
  const match = pw.length>0 && pw===pw2;
  async function save() {
    if (!allOk || !match || !cur) return;
    setState('saving'); setErr('');
    try {
      // Confirm the current password (does not affect login rate-limits).
      try {
        await api.post('/auth/verify-password', { password: cur });
      } catch(e) {
        setState('error'); setErr('Your current password is incorrect.'); return;
      }
      await api.put(`/users/${user.id}`, { new_password: pw });
      setState('done');
      // Changing the password invalidates every session (this one included), so
      // send the user to log in again with the new password.
      setTimeout(()=>{ onLogout(); }, 1400);
    } catch(e) {
      setState('error'); setErr(e?.error || 'Could not change password.');
    }
  }
  const field = { width:'100%', padding:'9px 11px', borderRadius:'8px', border:'1px solid var(--border)', fontSize:'13px', background:'var(--surface)', color:'var(--text)', boxSizing:'border-box' };
  return (
    <div className="modal-overlay">
      <div className="modal" style={{width:'420px',maxWidth:'94vw'}}>
        <h3 style={{fontSize:'16px',fontWeight:'700',color:'var(--text)',margin:'0 0 4px'}}>🔐 Change my password</h3>
        <p style={{fontSize:'12px',color:'var(--muted)',marginBottom:'14px'}}>You will be signed out and asked to log in again with your new password.</p>
        {state==='done' ? (
          <div style={{padding:'20px 0',textAlign:'center'}}>
            <div style={{fontSize:'14px',fontWeight:'700',color:'#16A34A'}}>✓ Password changed</div>
            <div style={{fontSize:'12px',color:'var(--muted)',marginTop:'6px'}}>Signing you out…</div>
          </div>
        ) : (
          <>
            <div style={{marginBottom:'10px'}}>
              <label style={{fontSize:'12px',fontWeight:'600',color:'var(--text)',display:'block',marginBottom:'4px'}}>Current password</label>
              <input type="password" value={cur} onChange={e=>{setCur(e.target.value);setState('idle');}} style={field} autoComplete="current-password"/>
            </div>
            <div style={{marginBottom:'10px'}}>
              <label style={{fontSize:'12px',fontWeight:'600',color:'var(--text)',display:'block',marginBottom:'4px'}}>New password</label>
              <input type="password" value={pw} onChange={e=>{setPw(e.target.value);setState('idle');}} style={field} autoComplete="new-password"/>
            </div>
            <div style={{marginBottom:'10px'}}>
              <label style={{fontSize:'12px',fontWeight:'600',color:'var(--text)',display:'block',marginBottom:'4px'}}>Confirm new password</label>
              <input type="password" value={pw2} onChange={e=>{setPw2(e.target.value);setState('idle');}} style={field} autoComplete="new-password"/>
              {pw2.length>0 && !match && <div style={{fontSize:'11px',color:'#DC2626',marginTop:'4px'}}>Passwords do not match</div>}
            </div>
            <div style={{background:'var(--surface2)',borderRadius:'8px',padding:'9px 12px',margin:'12px 0'}}>
              {rules.map(([ok,label])=>(
                <div key={label} style={{fontSize:'11px',color:ok?'#16A34A':'var(--muted)',display:'flex',alignItems:'center',gap:'6px',padding:'1px 0'}}>
                  <span>{ok?'✓':'○'}</span>{label}
                </div>
              ))}
            </div>
            {err && <div style={{fontSize:'12px',fontWeight:'600',color:'#DC2626',marginBottom:'10px'}}>{err}</div>}
            <div style={{display:'flex',gap:'8px',justifyContent:'flex-end'}}>
              <button className="btn" onClick={onClose} disabled={state==='saving'}>Cancel</button>
              <button onClick={save} disabled={!allOk||!match||!cur||state==='saving'}
                style={{padding:'8px 18px',borderRadius:'8px',border:'none',background:(!allOk||!match||!cur)?'#9CA3AF':'#5B5BD6',color:'#fff',fontSize:'13px',fontWeight:'700',cursor:(!allOk||!match||!cur)?'default':'pointer',minWidth:'130px'}}>
                {state==='saving'?'Changing…':'Change password'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

const PREF_META = [
  ['assignment',    'Task assignments',   'When you are assigned to a task'],
  ['comment',       'Comments',           'When someone comments on a task you own'],
  ['mention',       'Mentions',           'When someone @mentions you in a comment'],
  ['payment',       'Payments',           'Payment milestone activity'],
  ['phase_access',  'Access granted',     'When you are given access to a project or phase'],
  ['deadline',      'Deadline reminders', 'Upcoming and overdue task reminders'],
  ['escalation',    'Escalations',        'When a task is escalated'],
  ['weekly_summary','Weekly summary',     'The weekly project summary email'],
];

function NotificationPrefsModal({ onClose }) {
  const [prefs, setPrefs] = useState(null);
  const [saveState, setSaveState] = useState('idle'); // idle | saving | saved | error
  const [errMsg, setErrMsg] = useState('');
  useEffect(() => {
    api.get('/my/notification-prefs').then(p=>setPrefs(p)).catch(()=>setPrefs({}));
  }, []);
  async function save() {
    setSaveState('saving'); setErrMsg('');
    try {
      await api.put('/my/notification-prefs', prefs);
      setSaveState('saved');
      setTimeout(()=>onClose(), 1100);
    } catch(e){ setSaveState('error'); setErrMsg(e?.error||'Could not save. Please try again.'); }
  }
  const btn = {
    idle:  { label:'Save preferences', bg:'#5B5BD6', disabled:false },
    saving:{ label:'Saving…',          bg:'#7C7CE0', disabled:true  },
    saved: { label:'✓ Saved',          bg:'#16A34A', disabled:true  },
    error: { label:'Try again',        bg:'#DC2626', disabled:false },
  }[saveState];
  return (
    <div className="modal-overlay">
      <div className="modal" style={{width:'440px',maxWidth:'94vw'}}>
        <h3 style={{fontSize:'16px',fontWeight:'700',color:'var(--text)',margin:'0 0 4px'}}>🔔 My Notifications</h3>
        <p style={{fontSize:'12px',color:'var(--muted)',marginBottom:'14px'}}>Choose which notifications you want to receive. These apply to you only.</p>
        {!prefs ? <div style={{padding:'20px',textAlign:'center',color:'var(--muted)',fontSize:'13px'}}>Loading…</div>
          : PREF_META.map(([key,label,desc])=>(
            <div key={key} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'11px 0',borderBottom:'1px solid var(--border)'}}>
              <div style={{paddingRight:'12px'}}>
                <div style={{fontSize:'13px',fontWeight:'600',color:'var(--text)'}}>{label}</div>
                <div style={{fontSize:'11px',color:'var(--muted)',marginTop:'1px'}}>{desc}</div>
              </div>
              <div onClick={()=>{ if(saveState==='saved')return; setSaveState('idle'); setPrefs(p=>({...p,[key]:p[key]===false})); }} style={{cursor:'pointer',flexShrink:0}}>
                <div style={{width:44,height:24,borderRadius:12,background:(prefs[key]!==false)?'#5B5BD6':'#D1D5DB',display:'flex',alignItems:'center',padding:'2px',transition:'background .2s'}}>
                  <div style={{width:20,height:20,borderRadius:'50%',background:'#fff',transform:(prefs[key]!==false)?'translateX(20px)':'translateX(0)',transition:'transform .2s'}}/>
                </div>
              </div>
            </div>
          ))
        }
        {saveState==='error' && <div style={{fontSize:'12px',fontWeight:'600',color:'#DC2626',marginTop:'12px'}}>{errMsg}</div>}
        {saveState==='saved' && <div style={{fontSize:'12px',fontWeight:'600',color:'#16A34A',marginTop:'12px'}}>Your notification preferences have been updated.</div>}
        <div style={{display:'flex',gap:'8px',justifyContent:'flex-end',marginTop:'18px'}}>
          <button className="btn" onClick={onClose} disabled={saveState==='saving'}>Close</button>
          <button onClick={save} disabled={btn.disabled||!prefs}
            style={{padding:'8px 18px',borderRadius:'8px',border:'none',background:btn.bg,color:'#fff',fontSize:'13px',fontWeight:'700',cursor:btn.disabled?'default':'pointer',transition:'background .2s',minWidth:'140px'}}>
            {btn.label}
          </button>
        </div>
      </div>
    </div>
  );
}
